/* eslint-disable no-plusplus */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-expressions */
/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";
// react-table components
import { useTable, usePagination, useGlobalFilter, useAsyncDebounce, useSortBy } from "react-table";

// @mui material components
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Icon from "@mui/material/Icon";
import Autocomplete from "@mui/material/Autocomplete";
import lod_ from "lodash";
import i18n, { t } from "i18next";
// Material Dashboard 2 PRO React components
import { useDispatch, useSelector } from "react-redux";
import ChartsActions from "redux-react/actions/chartsActions";
import { selectCurrentProfile } from "redux-react/reducers/profileReducer";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import MDInput from "components/Basics/MDInput";
import MDPagination from "components/Basics/MDPagination";
import DownloadCSV from "components/Custom/DownloadCSV";
import MDButton from "components/Basics/MDButton";
import ListOptions from "components/Custom/ListOptions";
import {
	Card,
	Checkbox,
	GridLegacy as Grid,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	Menu,
	MenuItem,
	Tooltip
} from "@mui/material";
// Material Dashboard 2 PRO React examples
import DataTableHeadCell from "./DataTableHeadCell";
import DataTableBodyCell from "./DataTableBodyCell";
import { handleSpecialCell } from "./functions";

const DefaultDataTable = ({
	// Selection
	checkbox = false, // Display checkbox or not ()
	onRowClick = () => {}, // Triggered When no checkbox to handle click on row
	isSelectedRow = () => {
		// Check if the row is selected, override this in component
		return false;
	},
	selectedRows = [], // Selected rows, state must be managed by component
	handleSelection = () => {}, // Triggered when checkbox and a row is selected => return selected rows
	checkboxUniqueValue = "code", // Unique value to identify the row in checkbox selection
	//
	route = {},
	//
	reloadTable,
	//
	noMargin = false,
	//
	headerAction = null,
	//
	displayDictionaryName = null,
	setReloadTable = () => {},
	loadCharts = () => {},
	form = {},
	list = {},
	/**
	 * Actions can be an array of components or a function that return a component
	 * e.g : (row) => <MyComponent row={row} />
	 * (Array: old way for backward compatibility)
	 */
	actions = null,
	canSearch = true,
	showTotalEntries = true,
	table = {
		rows: [],
		columns: []
	},
	pagination = {
		defaultEntrie: 10,
		entriesPerPage: [5, 10, 15, 20, 25]
	},
	isSorted = false,
	noHeader = false,
	noEndBorder = false,
	handleChangeEntriesPerPage = null,
	dictionary = {},
	display = [],
	actionDeleteHandle = null,
	actionEditHandle = null,
	actionLanguageDefault = null,
	filters,
	optionsAction = "left",
	formSelectUpdate = false,
	extra = {}, // Extra props
	compact = false, // Display compact table (reducing padding / margin / ...)
	onSorted,
	placeHolderEmptyMessage = null, // String: Message to display when no data in table, if null, no message
	fixedLayout = false // Boolean: set table layout to fixed
}) => {
	const profile = useSelector(selectCurrentProfile);
	const dispatch = useDispatch();
	let defaultEntrie = pagination?.defaultEntrie;
	let entriesPerPage = pagination?.entriesPerPage;
	const [defaultValue, setDefaultValue] = useState(defaultEntrie ?? 10);

	const entries = entriesPerPage
		? entriesPerPage.map(el => el.toString())
		: ["5", "10", "15", "20", "25"];

	const { columns } = table;
	const [data, setData] = useState(table.rows);
	const [count, setCount] = useState(table.count ?? (table.rows ?? []).length);

	const sortOrder = [0, 1, -1];
	const [tableSort, setTableSort] = useState({});
	/**
	 * 1 = asc
	 * 0 = default, no sort
	 * -1 = desc
	 */

	const [attributeToDisplay, setAttributeToDisplay] = useState(display);

	const getSort = colID => {
		return tableSort[colID] ?? 0;
	};

	const selectNextSort = colID => {
		const actualSort = tableSort[colID] ?? 0;

		const sort = sortOrder.indexOf(actualSort);
		const nextSort = sortOrder[(sort + 1) % sortOrder.length];
		if (nextSort === 0) {
			onSorted?.(colID, nextSort);
			setTableSort({});
		} else {
			onSorted?.(colID, nextSort);
			setTableSort({ [colID]: nextSort });
		}
		// in case we want to sort by firstName, and after lastName, etc ... => setTableSort({ ...tableSort, [colID]: nextSort });
	};

	const { totalRow } = table;

	const tableInstance = useTable(
		{ columns, data, initialState: { pageIndex: 0 } },
		useGlobalFilter,
		useSortBy,
		usePagination
	);

	let {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		prepareRow,
		rows,
		page,
		pageOptions,
		canPreviousPage,
		canNextPage,
		gotoPage,
		nextPage,
		previousPage,
		setPageSize,
		setGlobalFilter,
		state: { pageIndex, pageSize, globalFilter }
	} = tableInstance;

	const [actualPage, setActualPage] = useState(1);

	// Set the default value for the entries per page when component mounts
	useEffect(() => setPageSize(defaultValue || 10), [defaultValue]);

	// Set the entries per page value based on the select value
	const setEntriesPerPage = value => setPageSize(value);

	// Handler for the input to set the pagination index
	const handleInputPagination = ({ target: { value } }) =>
		value > pageOptions.length || value < 0 ? gotoPage(0) : gotoPage(Number(value));

	// Customized page options starting from 1
	const customizedPageOptions = pageOptions.map(option => option + 1);

	// Setting value for the pagination input
	const handleInputPaginationValue = ({ target: value }) => gotoPage(Number(value.value - 1));

	// Search input value state
	const [search, setSearch] = useState(globalFilter);
	const [customSearch, setCustomSearch] = useState("");

	// Search input state handle
	const onSearchChange = useAsyncDebounce(value => {
		setGlobalFilter(value || undefined);
	}, 100);

	// Setting the entries starting point
	let entriesStart = pageIndex === 0 ? pageIndex + 1 : pageIndex * pageSize + 1;

	// Setting the entries ending point
	let entriesEnd;

	if (pageIndex === 0) {
		entriesEnd = pageSize;
	} else if (pageIndex === pageOptions.length - 1) {
		entriesEnd = rows.length;
	} else {
		entriesEnd = pageSize * (pageIndex + 1);
	}

	/**
	 * When pagination is active, the entries start and end are calculated based on the actual page
	 */
	if (pagination) {
		entriesStart = defaultValue * actualPage - defaultValue + 1;
		if (entriesStart < 0) entriesStart = 0;
		entriesEnd = defaultValue * actualPage;

		canPreviousPage = actualPage > 1;
		canNextPage = entriesEnd < count;
	}
	/**
	 * Get the maximum page that can be reached by the input
	 * @returns
	 */
	const getMaxInputValue = cc => {
		if (pagination) {
			return Math.ceil((cc || count) / defaultValue);
		} else {
			return customizedPageOptions.length;
		}
	};
	/**
	 * Go to a specific page, request in DB
	 */
	const goToPagePagination = (
		page = actualPage,
		val = defaultValue,
		searchVal = customSearch,
		sort = tableSort
	) => {
		if (!lod_.isNil(list) && !lod_.isEmpty(list)) {
			/**
			 * If we have a list that's mean the chart is dynamic and we must reload data from DB
			 */

			/**
			 * Database response
			 * @param {object} res response from DB
			 */
			const onSuccess = res => {
				setCount(res.data.count);
				setData(res.data.paginedList);

				if (page < 1) {
					page = 1;
				}
				if (page > getMaxInputValue(res.data.count)) {
					page = getMaxInputValue(res.data.count);
				}

				setActualPage(page);

				let maxPage = Math.ceil(res.data.count / val);
				if (maxPage > 0 && page > maxPage) {
					page = maxPage;
					goToPagePagination(page, val, searchVal);
				}
			};

			let profileSystem = false;
			if (profile?.system === true) profileSystem = true;
			dispatch(
				ChartsActions.refreshPaginedList(
					list,
					val,
					page,
					route,
					searchVal,
					sort,
					{ ...filters, ...list.filters },
					profileSystem,
					onSuccess
				)
			);
		} else {
			/**
			 * If no list, we have all data in the table props, we sort and pagine locally
			 */
			if (page > getMaxInputValue(count)) {
				page = getMaxInputValue(count);
			}
			if (page < 1) {
				page = 1;
			}

			setActualPage(page);

			let rows = lod_.cloneDeep(table.rows);

			/**
			 * Search
			 */
			if (searchVal && searchVal.trim() !== "") {
				const searchLower = searchVal.trim().toLowerCase();
				rows = rows.filter(row => {
					let keep = false;
					Object.keys(row).forEach(key => {
						if (!(display || []).includes(key)) {
							return;
						}

						let value = row[key];
						if (!lod_.isNil(value) && value.toString().toLowerCase().includes(searchLower)) {
							keep = true;
						}
					});
					return keep;
				});
			}

			/**
			 * sort is object like {name: 1} or {code: -1, name: 1} .... etc, sort rows locally
			 */
			if (sort && !lod_.isEmpty(sort)) {
				const sortKeys = Object.keys(sort);
				rows.sort((a, b) => {
					for (let i = 0; i < sortKeys.length; i++) {
						const key = sortKeys[i];
						if (a[key] < b[key]) {
							return -1 * sort[key];
						}
						if (a[key] > b[key]) {
							return 1 * sort[key];
						}
						// a must be equal to b, go to next key
					}
					return 0;
				});
			}

			const skip = (page - 1) * val;
			const limit = skip + val;

			// Skip & limit rows
			const newData = rows.filter((el, index) => index >= skip && index < limit);

			setData(newData);
		}
	};
	/**
	 * Update the entries per page
	 */
	function handleChangeEntries(newValue) {
		setDefaultValue(newValue);
		goToPagePagination(actualPage, newValue, customSearch);
	}
	/**
	 * Handle the previous page
	 * @param {*} e
	 */
	const handlePreviousPage = e => {
		if (pagination) {
			goToPagePagination(actualPage - 1, defaultValue, customSearch);
		} else {
			previousPage();
		}
	};
	/**
	 * Handle the next page
	 * @param {*} e
	 */
	const handleNextPage = e => {
		if (pagination) {
			goToPagePagination(actualPage + 1, defaultValue, customSearch);
		} else {
			nextPage();
		}
	};
	/**
	 * Handle the change of the page (in input)
	 * @param {*} e
	 */
	const handleChangePage = e => {
		if (pagination) {
			let { value } = e.target;
			if (value < 1) value = 1;
			goToPagePagination(value, defaultValue, customSearch);
		} else {
			handleInputPagination(e);
			handleInputPaginationValue(e);
		}
	};
	/**
	 * Get the actual page
	 * @returns
	 */
	const getActualPage = () => {
		if (pagination) {
			return actualPage;
		} else {
			return customizedPageOptions[pageIndex];
		}
	};
	/**
	 * Search
	 */
	function handleSearch(value) {
		if (pagination && !lod_.isNil(list)) {
			setCustomSearch(value);
			if (value.trim()) {
				goToPagePagination(1, defaultValue, value);
			} else {
				goToPagePagination(1, defaultValue, null);
			}
		} else {
			setSearch(value);
			onSearchChange(value);
		}
	}

	// Debounced search function
	const debouncedHandleSearch = lod_.debounce(handleSearch, 300);

	/**
	 * Check if the table has actions
	 */
	const hasActions = actionEditHandle || actionDeleteHandle;
	/**
	 * Display total line at the end of the table
	 */
	function getTotalRow() {
		if (totalRow) {
			return (
				<TableRow>
					{Object.keys(totalRow).map((key, index) => (
						<DataTableBodyCell
							compact={compact}
							style={{
								fontWeight: "900"
							}}
							key={index}
						>
							{totalRow[key] ?? 0}
						</DataTableBodyCell>
					))}
				</TableRow>
			);
		} else {
			return null;
		}
	}
	/**
	 * ##############################
	 * Handle specials actions in props
	 * -> allow to custom actions with row values
	 * e.g : disabe, click, loadingn style
	 * ##############################
	 */
	function overrideObjectProps(action, row) {
		// custom disabled method
		const checkDisabled = act => {
			if (act.props?.disabled) {
				return act.props.disabled;
			} else if (act.props?.customdisabled) {
				return act.props.customdisabled(row);
			} else {
				return false;
			}
		};
		// custom style
		const customStyle = act => {
			let style = act.props?.style ?? {};
			if (act.props?.customstyle) {
				style = act.props.customstyle(row, style);
			}
			return style;
		};

		const customLoading = act => {
			if (act.props?.loading) {
				let loadingObject = act.props.loading(row);
				if (loadingObject.loading) {
					return loadingObject.component;
				}
			}

			if (act.props?.customicon) {
				return act.props.customicon(row);
			}

			return act.props?.children;
		};

		action = {
			...action,
			props: {
				...action.props,
				onClick(e) {
					action.props?.handleclick ? action.props?.handleclick(row, e) : null;
				},
				disabled: checkDisabled(action),
				style: customStyle(action),
				children: customLoading(action),
				// Pass extra param to props rowvalues
				rowvalues: row.values
			}
		};

		if (action.props.children && lod_.isObject(action.props.children)) {
			action.props.children = overrideObjectProps(action.props.children, row);
		}

		return action;
	}

	const handleSelectRow = (original, values) => {
		// 1- If in form and no checkbox, we edit the row
		if (formSelectUpdate && !checkbox) {
			actionEditHandle(values);
			return;
		}

		// 2- If no checkbox, onClick event
		if (!checkbox) {
			onRowClick(values, original);
			return;
		}

		// 3- If checkbox, we select the row
		let newSelectedRows = [];
		if (selectedRows.includes(original) || isSelectedRow(original)) {
			newSelectedRows = selectedRows.filter(item => {
				const rowComparison = lod_.get(original, checkboxUniqueValue, null);
				const itemComparison = lod_.get(item, checkboxUniqueValue, null);

				return (
					item.uuid !== original.uuid ||
					item.code !== original.code ||
					item.uuid !== original.uuid ||
					item.url !== original.url ||
					rowComparison !== itemComparison
				);
			});
		} else {
			newSelectedRows = [...selectedRows, original];
		}
		handleSelection(newSelectedRows, original);
	};

	const selectAllRows = () => {
		if (!checkbox) return;
		let newSelectedRows = [];
		if (selectedRows.length === rows.length) {
			handleSelection(newSelectedRows);
		} else {
			rows.map(row => {
				newSelectedRows.push(row.original);
			});
			handleSelection(newSelectedRows);
		}
	};

	const [prevFilters, setPrevFilters] = useState(null);

	const [anchorMoreVertFormMenu, setAnchorMoreVertFormMenu] = useState(null);
	const handleCloseMoreVertFormMenu = () => {
		setAnchorMoreVertFormMenu(null);
	};
	/**
	 * Menu for pagined list
	 * use dicitonary & form
	 * allow user to display fields of the collection
	 */
	const renderMoreVertFormMenu = () => {
		// Dictionary
		let objectCollection = lod_.get(dictionary, form.routeDictionary);

		if (!objectCollection) {
			return <Menu></Menu>;
		}
		if (objectCollection?.type === "level") objectCollection = objectCollection?.items;
		// Columns
		let filteredColumns = [];

		Object.entries(objectCollection).map(([key, value]) => {
			if (value.display) {
				filteredColumns.push({
					Header: value.label.fr,
					accessor: key
				});
			}
		});

		/**
		 * Handle click on item
		 */
		const updateItemFromAttributeToDisplay = attribute => {
			let newAttributeToDisplay = [...attributeToDisplay];
			if (newAttributeToDisplay.includes(attribute)) {
				if (newAttributeToDisplay.length > 1) {
					newAttributeToDisplay = newAttributeToDisplay.filter(item => item !== attribute);
				}
			} else {
				newAttributeToDisplay.push(attribute);
			}

			// Order newAttributeToDisplay by dictionary order
			newAttributeToDisplay = newAttributeToDisplay.sort((a, b) => {
				let aOrder = objectCollection[a].order;
				let bOrder = objectCollection[b].order;

				if (aOrder < bOrder) {
					return -1;
				}
				if (aOrder > bOrder) {
					return 1;
				}
				return 0;
			});

			setAttributeToDisplay(newAttributeToDisplay);
			// Update display in DB
			dispatch(
				ChartsActions.updateAttributeDisplayPaginedList(list.code, newAttributeToDisplay, res => {
					loadCharts();
				})
			);
		};
		/**
		 * Menu
		 */
		return (
			<Menu
				id="long-menu"
				anchorEl={anchorMoreVertFormMenu}
				open={Boolean(anchorMoreVertFormMenu)}
				onClose={handleCloseMoreVertFormMenu}
			>
				{Object.keys(filteredColumns).map((item, index) => {
					let itemObject = filteredColumns[item];
					return (
						<MenuItem
							disabled={
								attributeToDisplay.includes(itemObject.accessor) && attributeToDisplay.length <= 1
							}
							key={index}
							onClick={() => {
								updateItemFromAttributeToDisplay(itemObject.accessor);
							}}
						>
							<MDBox>
								<Checkbox checked={attributeToDisplay.includes(itemObject.accessor)} />
							</MDBox>
							{itemObject.Header}
						</MenuItem>
					);
				})}
			</Menu>
		);
	};

	const getActionDelete = (row, collectionDefault) => {
		switch (collectionDefault) {
			case "profile":
				return <div></div>;

			default:
				return (
					<IconButton
						onClick={event => {
							actionDeleteHandle(row.values);
							event.stopPropagation();
							event.preventDefault();
						}}
					>
						<Icon fontSize="medium">delete</Icon>
					</IconButton>
				);
		}
	};

	const getRowStyle = row => {
		let className = "";
		if (onRowClick) {
			className += " defaultDataTableClickableRow";
		}
		if (isSelectedRow(row)) {
			className += " defaultDataTableSelectedRow";
		}
		return className;
	};

	useEffect(() => {
		if (lod_.isEqual(prevFilters, filters)) {
			goToPagePagination();
		} else {
			setPrevFilters(filters);
			goToPagePagination(0, defaultValue, customSearch);
		}
	}, [filters, tableSort]);

	useEffect(() => {
		if (lod_.isNil(reloadTable)) return;
		goToPagePagination();
	}, [reloadTable]);

	useEffect(() => {
		if (table.rows) {
			goToPagePagination();
		}
		if (!lod_.isNil(table.count)) {
			setCount(table.count);
		}
	}, [table.rows]);

	const [informationModal, setInformationModal] = useState({
		open: false,
		content: null
	});

	return (
		<Grid flex="1" display="flex" flexDirection="column" sx={{ height: "100%" }}>
			<Dialog open={informationModal.open} fullWidth maxWidth="md">
				<DialogTitle></DialogTitle>
				<DialogContent>{informationModal.content}</DialogContent>
				<DialogActions>
					<MDButton
						onClick={() => {
							setInformationModal({ open: false, content: null });
						}}
						color="info"
						variant="outlined"
					>
						{t("SETTINGS.close")}
					</MDButton>
				</DialogActions>
			</Dialog>
			<MDBox
				mt={noMargin ? 0 : 5}
				flex="1"
				display="flex"
				flexDirection="column"
				sx={{ height: "100%" }}
			>
				<Card
					style={{
						flex: 1,
						height: "100%",
						display: "flex",
						flexDirection: "column",
						boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)"
					}}
				>
					<MDBox
						py={2}
						pr={2}
						pl={list?.display?.icon?.component ? 1 : 2}
						flex="1"
						display="flex"
						flexDirection="column"
						style={
							compact
								? {
										height: "100%",
										padding: "15px",
										margin: 0,
										borderRadius: 0,
										backgroundColor: "white"
									}
								: { height: "100%" }
						}
					>
						{!noHeader && !lod_.isEmpty(list) && (
							<MDBox display="flex" justifyContent="space-between" px={1} pt={1}>
								<MDBox display="flex">
									{list?.display?.icon?.component && (
										<MDBox
											width="4rem"
											height="4rem"
											bgColor={list?.display.icon.color || "info"}
											variant="gradient"
											coloredShadow={list?.display.icon.color || "info"}
											borderRadius="xl"
											display="flex"
											justifyContent="center"
											alignItems="center"
											color="white"
											mt={-5}
											mr={2}
										>
											<Icon fontSize="medium">{list?.display.icon.component}</Icon>
										</MDBox>
									)}
									<MDBox mt={list?.display?.icon?.component ? -2 : 0}>
										{list?.display?.title && (
											<MDTypography variant="h6">{list?.display?.title}</MDTypography>
										)}
										<MDBox mb={2}>
											<MDTypography component="div" variant="button" color="text">
												{list?.display?.description}
											</MDTypography>
										</MDBox>
									</MDBox>
								</MDBox>
								<MDBox mt={list?.display?.icon?.component ? -2 : 0}>
									{!lod_.isEmpty(list) && (
										<ListOptions
											chart={{
												...list,
												isSystem: list?.isSystem || route?.system,
												data
											}}
											options={list.options ?? {}}
										/>
									)}
								</MDBox>
							</MDBox>
						)}
						<MDBox
							flex="1"
							display="flex"
							flexDirection="column"
							p={1}
							style={{
								overflowY: "auto"
							}}
						>
							{/* Top */}
							{entriesPerPage || canSearch || headerAction ? (
								<MDBox
									display="flex"
									justifyContent="space-between"
									alignItems="center"
									p={1}
									pb={2}
									style={
										compact
											? { position: "sticky", paddingBottom: 0, paddingTop: 0 }
											: { position: "sticky" }
									}
								>
									<MDBox display="flex" alignItems="center">
										<Autocomplete
											disableClearable
											value={pageSize.toString()}
											options={entries}
											onChange={(event, newValue) => {
												if (pagination) {
													handleChangeEntries(newValue);
												} else {
													if (handleChangeEntriesPerPage) handleChangeEntriesPerPage(newValue);
													setEntriesPerPage(parseInt(newValue, 10));
												}
											}}
											size="small"
											sx={{ width: "5rem" }}
											renderInput={params => <MDInput {...params} />}
										/>
										<MDTypography variant="caption" color="secondary">
											&nbsp;&nbsp;{i18n.t("DATATABLE.entriesPerPage")}
										</MDTypography>
									</MDBox>
									{canSearch && (
										<MDBox flex="1" sx={{ ml: 5 }}>
											<MDInput
												placeholder={i18n.t("DATATABLE.search")}
												// value={search}
												size="small"
												fullWidth
												onChange={({ currentTarget }) => {
													debouncedHandleSearch(currentTarget.value);
												}}
											/>
										</MDBox>
									)}
									{headerAction}
									{/* Only for form pages */}
									{dictionary && form?.routeDictionary && (
										<>
											<IconButton
												onClick={e => {
													setAnchorMoreVertFormMenu(e.currentTarget);
													e.preventDefault();
													e.stopPropagation();
												}}
											>
												<Icon>more_vert</Icon>
											</IconButton>
											{renderMoreVertFormMenu()}
										</>
									)}
								</MDBox>
							) : null}
							{/* Table */}

							{(lod_.isNil(placeHolderEmptyMessage) ||
								(!lod_.isNil(placeHolderEmptyMessage) && data.length > 0)) && (
								<TableContainer sx={{ boxShadow: "none", flex: 1 }}>
									<Table
										{...getTableProps()}
										sx={
											fixedLayout
												? {
														tableLayout: "fixed",
														width: "100%"
													}
												: {}
										}
									>
										<MDBox component="thead">
											{headerGroups.map((headerGroup, groupIndex) => (
												<TableRow {...headerGroup.getHeaderGroupProps()} key={groupIndex}>
													{(hasActions || actions) && optionsAction === "left" && (
														<DataTableHeadCell
															width={fixedLayout ? 70 : 20}
															align="right"
															compact={compact}
														>
															Actions
														</DataTableHeadCell>
													)}
													{checkbox && (
														<DataTableHeadCell
															width={fixedLayout ? 50 : 20}
															align="right"
															compact={compact}
														>
															<Checkbox
																checked={
																	selectedRows.length === rows.length && selectedRows.length > 0
																}
																onClick={() => {
																	selectAllRows();
																}}
																sx={{
																	py: 0
																}}
															/>
														</DataTableHeadCell>
													)}
													{headerGroup.headers.map((column, i) => {
														if (
															!attributeToDisplay ||
															lod_.isEmpty(attributeToDisplay) ||
															attributeToDisplay.includes(column.id)
														) {
															const help = column.Help;
															return (
																<DataTableHeadCell
																	key={i}
																	{...column.getHeaderProps(
																		isSorted && column.getSortByToggleProps()
																	)}
																	width={column?.cellWidth ?? "auto"}
																	align="left"
																	sorted={getSort(column.id)}
																	onClick={e => {
																		selectNextSort(column.id);
																	}}
																	boxStyle={column?.boxStyle ?? {}}
																	compact={compact}
																>
																	{help && (
																		<IconButton
																			color="info"
																			size="small"
																			onClick={e => {
																				help(column);

																				setInformationModal({
																					open: true,
																					content: column.render("Help")
																				});

																				e.stopPropagation();
																				e.preventDefault();
																			}}
																		>
																			<Icon>info</Icon>
																		</IconButton>
																	)}
																	{column.render("Header")}
																</DataTableHeadCell>
															);
														}
														return null;
													})}
													{(hasActions || actions) && optionsAction !== "left" && (
														<DataTableHeadCell width={20} align="right" compact={compact}>
															Actions
														</DataTableHeadCell>
													)}
												</TableRow>
											))}
										</MDBox>
										<TableBody {...getTableBodyProps()}>
											{page.map((row, key) => {
												prepareRow(row);
												return (
													<TableRow
														key={key}
														{...row.getRowProps()}
														onClick={() => {
															handleSelectRow(row.original, row.values);
														}}
														className={getRowStyle(row.original)}
													>
														{actions && optionsAction === "left" && (
															<DataTableBodyCell align="center" compact={compact}>
																<MDBox display="flex" justifyContent="flex-end">
																	{lod_.isFunction(actions) && actions(row)}
																	{!lod_.isFunction(actions) &&
																		actions.map((action, index) => {
																			action = overrideObjectProps(action, row);
																			return <span key={index}>{action}</span>;
																		})}
																</MDBox>
															</DataTableBodyCell>
														)}
														{hasActions && optionsAction === "left" && (
															<DataTableBodyCell compact={compact}>
																{form.collectionDefault === "language" ? (
																	<IconButton
																		onClick={event => {
																			actionLanguageDefault(row.values);
																			event.stopPropagation();
																			event.preventDefault();
																		}}
																	>
																		<Icon fontSize="medium">check</Icon>
																	</IconButton>
																) : (
																	<IconButton
																		onClick={event => {
																			actionEditHandle(row.values);
																			event.stopPropagation();
																			event.preventDefault();
																		}}
																	>
																		<Icon fontSize="medium">edit</Icon>
																	</IconButton>
																)}

																{getActionDelete(row, form?.collectionDefault)}
															</DataTableBodyCell>
														)}
														{checkbox && (
															<DataTableBodyCell align="right" compact={compact}>
																<Checkbox
																	checked={
																		selectedRows.includes(row.original) ||
																		isSelectedRow(row.original)
																	}
																	onClick={e => {
																		e.stopPropagation();
																		e.preventDefault();
																		handleSelectRow(row.original);
																	}}
																/>
															</DataTableBodyCell>
														)}
														{row.cells.map((cell, i) => {
															if (
																!attributeToDisplay ||
																lod_.isEmpty(attributeToDisplay) ||
																attributeToDisplay.includes(cell.column.id)
															) {
																return (
																	<DataTableBodyCell
																		key={i}
																		noBorder={noEndBorder && rows.length - 1 === key}
																		align={cell.column.align ? cell.column.align : "left"}
																		{...cell.getCellProps()}
																		className={`cell_${cell.column.id.replace(".", "_")}`}
																		compact={compact}
																		boxStyle={cell?.column?.boxStyle ?? {}}
																	>
																		{handleSpecialCell(
																			cell,
																			key,
																			dictionary,
																			form,
																			list,
																			displayDictionaryName,
																			extra,
																			data,
																			isSelectedRow(row.original)
																		)}
																	</DataTableBodyCell>
																);
															}
															return null;
														})}
														{actions && optionsAction !== "left" && (
															<DataTableBodyCell align="center" compact={compact}>
																<MDBox display="flex" justifyContent="flex-end">
																	{lod_.isFunction(actions) && actions(row)}
																	{!lod_.isFunction(actions) &&
																		actions.map((action, index) => {
																			action = overrideObjectProps(action, row);
																			return <span key={index}>{action}</span>;
																		})}
																</MDBox>
															</DataTableBodyCell>
														)}
														{hasActions && optionsAction !== "left" && (
															<DataTableBodyCell compact={compact}>
																{form.collectionDefault === "language" ? (
																	<IconButton
																		onClick={event => {
																			actionLanguageDefault(row.values);
																			event.stopPropagation();
																			event.preventDefault();
																		}}
																	>
																		<Icon fontSize="medium">check</Icon>
																	</IconButton>
																) : (
																	<IconButton
																		onClick={event => {
																			actionEditHandle(row.values);
																			event.stopPropagation();
																			event.preventDefault();
																		}}
																	>
																		<Icon fontSize="medium">edit</Icon>
																	</IconButton>
																)}

																{getActionDelete(row, form?.collectionDefault)}
															</DataTableBodyCell>
														)}
													</TableRow>
												);
											})}
											{getTotalRow()}
										</TableBody>
									</Table>
								</TableContainer>
							)}

							{!lod_.isNil(placeHolderEmptyMessage) && data.length === 0 && (
								<MDBox flex="1" display="flex" justifyContent="center" alignItems="center">
									{lod_.isString(placeHolderEmptyMessage) ? (
										<MDTypography
											variant="h4"
											color="text"
											sx={{
												opacity: 0.6
											}}
										>
											{placeHolderEmptyMessage}
										</MDTypography>
									) : (
										placeHolderEmptyMessage
									)}
								</MDBox>
							)}

							{/* Bottom */}
							<MDBox
								display="flex"
								flexDirection={{ xs: "column", sm: "row" }}
								justifyContent="space-between"
								alignItems={{ xs: "flex-start", sm: "center" }}
								p={!showTotalEntries && pageOptions.length === 1 ? 0 : 1}
								style={compact ? { paddingBottom: 0 } : {}}
							>
								{showTotalEntries && (
									<MDBox mb={{ xs: 3, sm: 0 }}>
										<MDTypography variant="button" color="secondary" fontWeight="regular">
											{`${i18n.t("DATATABLE.showing")} ${entriesStart} ${i18n.t("DATATABLE.to")} ${
												count < entriesEnd ? count : entriesEnd
											} ${i18n.t("DATATABLE.entries")} (${count} ${i18n.t("DATATABLE.entries")})`}
										</MDTypography>
									</MDBox>
								)}
								{(pageOptions.length > 1 || pagination) && (
									<MDPagination variant="gradient" color="info">
										{canPreviousPage && (
											<MDPagination item onClick={handlePreviousPage}>
												<Icon sx={{ fontWeight: "bold" }}>chevron_left</Icon>
											</MDPagination>
										)}
										<MDBox mr={1}>
											<MDInput
												inputProps={{ type: "number", min: 1, max: getMaxInputValue() }}
												value={getActualPage()}
												onChange={handleChangePage}
											/>
										</MDBox>
										<MDBox mr={1}>
											<MDTypography
												fontSize="small"
												variant="body1"
											>{`/ ${getMaxInputValue()}`}</MDTypography>
										</MDBox>
										{canNextPage && (
											<MDPagination item onClick={handleNextPage}>
												<Icon sx={{ fontWeight: "bold" }}>chevron_right</Icon>
											</MDPagination>
										)}
									</MDPagination>
								)}
							</MDBox>
						</MDBox>
					</MDBox>
				</Card>
			</MDBox>
		</Grid>
	);
};

export default DefaultDataTable;
